"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const index_1 = require("../../index");
const style_1 = require("./style");
const RotaTag = ({ tags = [], isReadOnly = false, onDeleteTag, onAddTag, emptyMessage, styles, styleTag, iconStyle, isOrange = false, isDelete = false }) => {
    const onHandle = (tag) => {
        if (onDeleteTag) {
            onDeleteTag(tag.id);
        }
        else {
            onAddTag && onAddTag(tag);
        }
    };
    return tags.length ? (react_1.default.createElement(react_1.default.Fragment, null, tags.map(tag => (react_1.default.createElement(style_1.StyledRotaTag, { key: tag === null || tag === void 0 ? void 0 : tag.id, isOrange: isOrange, style: Object.assign({}, styleTag) },
        react_1.default.createElement(style_1.StyledWrapName, null, tag === null || tag === void 0 ? void 0 : tag.name),
        !isReadOnly && (react_1.default.createElement(index_1.RotaButtonCircle, { onHandle: () => onHandle(tag), isDelete: isDelete, styles: styles, iconStyle: iconStyle }))))))) : (react_1.default.createElement(style_1.StyledMessage, null, emptyMessage));
};
exports.default = RotaTag;
